
import Vue from 'vue'
import BgImgBtnBlock from '../bg-img-btn-block/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'BgImgBtnTable',
  components: { BgImgBtnBlock },
  mixins: [staticBlockMixin],
  props: {
    imageLimit: {
      type: Boolean,
      required: false,
      default: false
    }
  }
})
